import React from "react"
import withStyles from "react-jss"
import colors from "../data/colors"

const styles = {
  link: {
    color: ({ color }) => (color ? color : colors.black),
    fontWeight: 600,
    "&:hover": {
      color: colors.buttonBlue,
    },
  },
}

const Link = ({ classes, url, text, affiliate }) => {
  const onClick = (url) => {
    if (window.parent && window.parent.dataLayer) {
      window.parent.dataLayer.push({
        event: "datavisualization-wiredHeadphoneQuiz-linkClick",
        "gtm.elementUrl": url,
      })
    }
  }
  return (
    <a
      className={classes.link}
      href={url}
      target="_blank"
      rel={`noreferrer${affiliate ? " nofollow" : ""}`}
      onClick={() => onClick(url)}>
      {text}
    </a>
  )
}

export default withStyles(styles)(Link)
